export default "__VITE_ASSET__DDf084NW__"